import { runApp } from "./app.js";

runApp();
